<div class="velocity-form-container">
  <form [formGroup]="velocityForm" (ngSubmit)="onSubmit()">
    <div class="font-bold">Weather Types:</div>
    <select
      id="weatherType"
      class="border border-gray-300 h-[35px] rounded-md w-full px-2 text-gray-700 focus:ring-blue-500 focus:border-blue-500"
      formControlName="weatherType"
    >
      <option *ngFor="let type of weatherTypes" [value]="type">
        {{ type | titlecase }}
      </option>
    </select>
    <label>
      Min Velocity:
      <input type="number" formControlName="minVelocity" />
    </label>

    <label>
      Max Velocity:
      <input type="number" formControlName="maxVelocity" />
    </label>

    <label>
      Velocity Scale:
      <input type="number" step="0.001" formControlName="velocityScale" />
    </label>

    <label>
      Particle Multiplier:
      <input type="number" step="0.0001" formControlName="particleMultiplier" />
    </label>

    <label>
      Line Width:
      <input type="number" step="0.1" formControlName="lineWidth" />
    </label>

    <label>
      Color:
      <input formControlName="colorScale" placeholder="green,red,yellow" />
    </label>

    <button type="submit" [disabled]="!velocityForm.valid">Apply</button>
  </form>
</div>
